import { ErrorHandler, inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { LogErrorService } from '@shared/services/log-error.service';
import packageJson from '../../../../package.json';

@Injectable({ providedIn: 'root' })
export class SentryErrorHandlerInterceptor implements ErrorHandler {
  private LogErrorService = inject(LogErrorService);
  private handledChunkError = false;

  public handleError(error: unknown): void {
    if (isChunkLoadError(error)) this.handleChunkLoadFailure(error);
    else this.sendToSentry(error);
  }

  private handleChunkLoadFailure(errorEvent: any): void {
    if (this.handledChunkError) return;
    this.handledChunkError = true;

    setTimeout(() => {
      if (errorEvent?.target?.url) {
        try {
          location.replace(errorEvent?.target?.url);
        } catch (e) {
          location.reload();
        }
      } else location.reload();
    }, 0);
  }

  private sendToSentry(error: any): void {
    try {
      const originalError = error?.originalError || error;

      Sentry.captureException(originalError, {
        extra: { angularMessage: error?.message || String(error) },
        tags: { appVersion: packageJson.version }
      });
    } catch (sentryError) {
      this.LogErrorService.error('ERRO AO ENVIAR ERRO PARA O SENTRY:', sentryError);
    }
  }
}

export function isChunkLoadError(error: unknown): boolean {
  const errorWithMessage = error as { error?: { message?: unknown }; message?: unknown };
  const errorMessage = String(errorWithMessage?.error?.message || errorWithMessage?.message || '').toLowerCase();

  return (
    errorMessage.includes('ng0750') ||
    errorMessage.includes('failed to fetch dynamically imported module') ||
    errorMessage.includes('importing a module script failed') ||
    errorMessage.includes('failed to load module script') ||
    errorMessage.includes('is not a valid javascript mime type') ||
    errorMessage.includes('chunkloaderror') ||
    errorMessage.includes('chunk')
  );
}
